import { z } from 'zod/v4'
import { KanbanGroupKeySchema } from './types.kanbanKeys'

export const KanbanSubsectionListDataSchema = z.object({
  group: KanbanGroupKeySchema,
  data: z.array(z.record(z.string(), z.unknown())),
  pagination: z
    .object({
      page: z.number(),
      total: z.number(),
      hasMore: z.boolean(),
      limit: z.number().optional(),
    })
    .optional(),
})

export const KanbanSectionListDataSchema = z.object({
  group: KanbanGroupKeySchema,
  subsections: z.array(KanbanSubsectionListDataSchema),
})

export const KanbanListBlockDataSchema = z.object({
  view: z.literal('kanban'),
  sections: z.array(KanbanSectionListDataSchema),
  pagination: z
    .object({
      page: z.number(),
      total: z.number(),
      hasMore: z.boolean(),
      limit: z.number().optional(),
    })
    .optional(),
})

export type KanbanSubsectionListData = z.infer<
  typeof KanbanSubsectionListDataSchema
>
export type KanbanSectionListData = z.infer<typeof KanbanSectionListDataSchema>
export type KanbanListBlockData = z.infer<typeof KanbanListBlockDataSchema>

export const isKanbanListBlockData = (
  value: unknown,
): value is KanbanListBlockData =>
  KanbanListBlockDataSchema.safeParse(value).success
